// extracted by mini-css-extract-plugin
export default {"mobileMenu":"styles_mobileMenu__jgPy+","mobileMenuNav":"styles_mobileMenuNav__T52kB"};